import { SpritePreviewScene } from './game/scenes/SpritePreviewScene';
import Phaser from 'phaser';
import { GameConfig } from './game/GameConfig';
import './styles/main.css';

window.addEventListener('DOMContentLoaded', () => {
  const preview = window.location.pathname.replace(/\/$/, '') === '/sprite-preview';
  const game = new Phaser.Game(preview ? { ...GameConfig, width: 1100, height: 1600, scale: { mode: Phaser.Scale.NONE, width: 1100, height: 1600 }, scene: [SpritePreviewScene] } : GameConfig);
  if (import.meta.env.DEV) (window as Window & { blastArena?: Phaser.Game }).blastArena = game;
});
